import type { PlayerConfig } from './player.config';

import { usePlayerOptions } from './hooks/use-player-options';
import { VideoJS } from './videojs';
import { LoggerProvider } from '../../contexts/logger-context';

export function Player(props: PlayerConfig) {
  return (
    <LoggerProvider debug={props.debug}>
      <PlayerComponent {...props} />
    </LoggerProvider>
  );
}

function PlayerComponent(props: PlayerConfig) {
  const playerOptions = usePlayerOptions(props);

  return <VideoJS options={playerOptions} />;
}
